import React from 'react';
import { Inbox } from 'lucide-react';

export default function EmptyState({
  title,
  description,
  action,
  isLight,
}: {
  title: string;
  description: string;
  action?: React.ReactNode;
  isLight: boolean;
}) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div
        className={`w-12 h-12 rounded-xl flex items-center justify-center mb-3 ${
          isLight ? 'bg-neutral-100' : 'bg-neutral-800'
        }`}
      >
        <Inbox className={isLight ? 'text-neutral-400' : 'text-neutral-500'} size={22} />
      </div>
      <h3 className={`text-sm font-semibold ${isLight ? 'text-neutral-900' : 'text-white'}`}>{title}</h3>
      <p className={`text-sm mt-1 max-w-md ${isLight ? 'text-neutral-500' : 'text-neutral-400'}`}>{description}</p>
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
